import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57b36808"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StepReceivers" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "StepReceivers__title" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel mr-2" }, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "block",
  href: "/Шаблон загрузки заказов.xlsx",
  download: "Шаблон загрузки заказов.xlsx"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "StepReceivers__hint"
}
const _hoisted_10 = {
  key: 1,
  class: "StepReceivers__state mt-2"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "state__message message--failed" }, " Произошла ошибка при загрузке списка получателей ", -1))
const _hoisted_12 = {
  key: 2,
  class: "StepReceivers__list"
}
const _hoisted_13 = {
  key: 0,
  class: "StepReceivers__state mt-2"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "state__message" }, "Список пуст", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "text-gray-400 font-semibold text-sm mt-3 select-none"
}
const _hoisted_17 = { class: "ml-2" }
const _hoisted_18 = {
  class: "list__wrapper",
  ref: "templatewindow"
}
const _hoisted_19 = {
  key: 3,
  class: "StepReceivers__state mt-2"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "state__message" }, "Загрузка списка получателей...", -1))
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "StepReceivers__title my-2" }, "Выбранные получатели", -1))
const _hoisted_23 = { class: "flex items-center justify-between" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "StepReceivers__title" }, "Получатель", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_26 = { class: "StepReceivers__receiver mt-2" }
const _hoisted_27 = { class: "receiver__title" }
const _hoisted_28 = { class: "mt-2 text-sm" }
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-user mr-2" }, null, -1))
const _hoisted_31 = { class: "block" }
const _hoisted_32 = { class: "flex items-center mt-1" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-mobile mr-3" }, null, -1))
const _hoisted_34 = { class: "block" }
const _hoisted_35 = { class: "flex items-center mt-1" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-map-marker-alt mr-3" }, null, -1))
const _hoisted_37 = { class: "block" }
const _hoisted_38 = {
  key: 0,
  class: "mt-2 font-semibold"
}
const _hoisted_39 = {
  key: 0,
  class: "mt-3 flex items-center justify-end"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_templates_actions = _resolveComponent("templates-actions")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_file_loader = _resolveComponent("file-loader")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_receivers_list_item = _resolveComponent("receivers-list-item")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_templates_actions, {
          key: 0,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "is-delete": false,
          loading: _ctx.actions_state.is_actions_loading,
          "company-id": _ctx.companyId,
          "sender-id": _ctx.senderId,
          "city-id": _ctx.cityId,
          "load-by-sender-city-id": !Boolean(_ctx.cityId),
          "initial-value": _ctx.actions_state.initial_value,
          "is-receiver": true,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onCreate: _ctx.onReceiverCreate,
          onUpdate: _ctx.onReceiverUpdate
        }, null, 8, ["is-create", "is-update", "loading", "company-id", "sender-id", "city-id", "load-by-sender-city-id", "initial-value", "onCreate", "onUpdate"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.stepNumber) + ". Выберите получателя", 1),
        (_ctx.opened)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_the_button, {
                disabled: _ctx.disabled,
                onClick: _ctx.startCreate,
                class: _normalizeClass(["primary small text", { 'mr-3': _ctx.withExcel }])
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createTextVNode(" Новый получатель ")
                ]),
                _: 1
              }, 8, ["disabled", "onClick", "class"]),
              (_ctx.withExcel)
                ? (_openBlock(), _createBlock(_component_file_loader, {
                    key: 0,
                    accept: ".xlsx, .xls, .csv",
                    placeholder: "Загрузить из Excel",
                    loading: _ctx.excelLoading,
                    disabled: _ctx.disabled,
                    class: "primary small text mr-3",
                    onFileLoaded: _ctx.emitCreateFromExcel
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createTextVNode(" Загрузить из excel ")
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled", "onFileLoaded"]))
                : _createCommentVNode("", true),
              (_ctx.withExcel)
                ? (_openBlock(), _createElementBlock("a", _hoisted_7, [
                    _createVNode(_component_the_button, {
                      disabled: _ctx.disabled,
                      hint: "Скачать шаблон",
                      class: "primary small"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.opened)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.hint)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.hint), 1))
              : _createCommentVNode("", true),
            (_ctx.data_state.receivers.is_failed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_the_button, {
                    class: "primary small mt-2",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadReceivers(_ctx.data_state.receivers.pagination.current_page)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Обновить ")
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_the_input, {
                    value: _ctx.state.search_query,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.search_query) = $event)),
                    placeholder: "Поиск по номеру телефона, адресу и названию",
                    class: "mt-2 w-full",
                    disabled: _ctx.disabled,
                    onInput: _ctx.searchReceiver
                  }, null, 8, ["value", "disabled", "onInput"]),
                  (
                            !_ctx.data_state.receivers.is_loading &&
                            _ctx.data_state.receivers.list.length === 0
                        )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                    : _createCommentVNode("", true),
                  (
                            !_ctx.data_state.receivers.is_loading && _ctx.data_state.receivers.list.length > 0
                        )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("span", null, "Страница: " + _toDisplayString(_ctx.data_state.receivers.pagination.current_page), 1),
                        _createElementVNode("span", _hoisted_17, " Получателей: " + _toDisplayString(_ctx.data_state.receivers.list.length), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data_state.receivers.list, (receiver) => {
                      return (_openBlock(), _createBlock(_component_receivers_list_item, {
                        class: "StepReceivers__item",
                        key: receiver,
                        item: receiver,
                        disabled: _ctx.disabled,
                        selected: _ctx.selectedReceiversIds.includes(receiver.id),
                        onSubmit: _ctx.onReceiverSelect,
                        onUpdate: _ctx.startUpdate,
                        onDeleted: _ctx.onReceiverDeleted
                      }, null, 8, ["item", "disabled", "selected", "onSubmit", "onUpdate", "onDeleted"]))
                    }), 128))
                  ], 512)
                ])),
            (_ctx.data_state.receivers.is_loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_loader, { class: "primary" }),
                  _hoisted_20
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.receivers.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _hoisted_22,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.receivers, (receiver, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `receiver-${idx}`,
              class: "mb-2 border px-4 py-2"
            }, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                (!_ctx.isUpdate)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 0,
                      class: "second small text",
                      disabled: _ctx.disabled,
                      onClick: ($event: any) => (_ctx.emitReset(idx))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_25,
                        _createTextVNode(" Сбросить ")
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("p", _hoisted_27, _toDisplayString(receiver.title), 1),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("span", _hoisted_31, _toDisplayString(receiver.full_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("span", _hoisted_34, _toDisplayString(receiver.phone), 1)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("span", _hoisted_37, _toDisplayString(receiver.full_address), 1)
                  ]),
                  (Boolean(receiver.warehouse_id))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_38, " Самовывоз "))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.isUpdate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createVNode(_component_the_button, {
                      class: "primary small text",
                      disabled: _ctx.disabled,
                      onClick: ($event: any) => (_ctx.startUpdate(receiver))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_40,
                        _createTextVNode(" Редактировать ")
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}